import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Input, Button, theme, Grid, Flex, Spin } from 'antd';
import _ from 'lodash';

import config from '../../config';
import AuthHelper from '../../helpers/auth';
import GeneralHelper from '../../helpers/general';
import sengLogo from '../../images/seng-logo.svg';
import background from '../../images/auth-background.webp';

const { Text, Link } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;

const SignUpPage = (props) => {
	const { token } = useToken();
	const screens = useBreakpoint();
	const history = useHistory();
	const { getPublishedEvent, loginPageProps, requestSignUpOtp, resetPage, resetMeta, signUpPageProps } = props;
	const { loadingRequestSubmit, meta } = signUpPageProps;
	const { loading, event } = loginPageProps;

	// States
	const [disabled, setDisabled] = useState(true);
	const [email, setEmail] = useState('');
	const [lastName, setLastName] = useState('');
	const [firstName, setFirstName] = useState('');
	const [emailErrMsg, setEmailErrMsg] = useState(null);
	const [errMsg, setErrMsg] = useState(null);

	// Functions
	const handleRequestSignUpOtp = () => {
		requestSignUpOtp({ email, lastName, firstName });
	};

	useEffect(() => {
		// Check if already logged in
		const authenticated =  AuthHelper.isAuthenticated();
		if (authenticated) {
			history.push('/application');
		}

		// Get published event
		getPublishedEvent();

		return () => {
			resetPage();
			resetMeta();
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (meta && meta.code !== 200) {
			setErrMsg(meta.message);
		}

		return () => {
			setTimeout(() => {
				setErrMsg(null);
				resetMeta();
			}, 5000);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [meta]);

	useEffect(() => {
		if (email === '' || GeneralHelper.isEmailValid(email)) {
			setEmailErrMsg(null);
		}

		if (email.length > 4 && !GeneralHelper.isEmailValid(email)) {
			setEmailErrMsg('Invalid email');
		}

		if (
			!_.isEmpty(email) &&
			GeneralHelper.isEmailValid(email) &&
			!_.isEmpty(lastName) &&
			!_.isEmpty(firstName)
		) {
			setDisabled(false);
		} else {
			setDisabled(true);
		}
	}, [email, lastName, firstName]);

	// Fix for loading background image
	if (loading || !event) {
		return (
			<Flex
				justify="center"
				align="center"
				style={{ height: '100vh' }}
			>
				<Spin/>
			</Flex>
		);
	}

	return (
		<div
			style={{
				background: `url(${_.get(event, 'image_asset_id') ?
					`${config.api}/public/assets/events/published` : background})`,
				backgroundSize: 'cover',
				height: '100vh'
			}}
		>
			<div
				style={{
					height: screens.xs ? '80vh' : '100vh',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}
			>
				<Flex
					vertical
					style={{
						width: 535,
						backgroundColor: token.whiteColor,
						borderRadius: 20,
						padding: '41px 39px',
						boxShadow: '0px 4px 4px 0px #00000026'
					}}
				>
					<Flex
						justify="center"
						style={{ alignSelf: 'center', maxHeight: 56, marginBottom: 30 }}
					>
						<img
							src={sengLogo}
							alt="seng-logo"
							style={screens.xs ? { width: '100%' } : { height: '100%' }}
						/>
					</Flex>
					<Text
						style={{
							fontSize: 32,
							color: token.colorPrimary,
							fontWeight: 110,
							lineHeight: 1
						}}
					>
						{event ? event.name : 'HKUST Engineering Summer Camp Online Application System'}
					</Text>
					<div style={{ marginTop: 25, marginBottom: 13 }}>
						<Text
							strong
							style={{ color: token.colorPrimary, fontSize: 19 }}
						>
							Email Address
						</Text>
						<Input
							placeholder="Enter Email Address"
							size="large"
							value={email}
							onChange={e => setEmail(e.target.value)}
							style={{ marginTop: 8, height: 48 }}
						/>
						{emailErrMsg && <Text type="danger">{emailErrMsg}</Text>}
						{errMsg && <Text type="danger">{errMsg}</Text>}
					</div>
					<div style={{ marginBottom: 13 }}>
						<Text
							strong
							style={{ color: token.colorPrimary, fontSize: 19 }}
						>
							Family Name / Last Name
						</Text>
						<Input
							placeholder="Enter Family Name / Last Name"
							size="large"
							value={lastName}
							onChange={e => setLastName(e.target.value?.toUpperCase())}
							style={{ marginTop: 8, height: 48 }}
						/>
						{errMsg && <Text type="danger">{errMsg}</Text>}
					</div>
					<div style={{ marginBottom: 25 }}>
						<Text
							strong
							style={{ color: token.colorPrimary, fontSize: 19 }}
						>
							Given Name / First Name
						</Text>
						<Input
							placeholder="Enter Given Name / First Name"
							size="large"
							value={firstName}
							onChange={e => setFirstName(e.target.value)}
							style={{ marginTop: 8, height: 48 }}
						/>
						{errMsg && <Text type="danger">{errMsg}</Text>}
					</div>
					<div>
						<Button
							type="primary"
							size="large"
							disabled={disabled}
							loading={loadingRequestSubmit}
							style={{ width: '100%', borderRadius: 50, height: 56 }}
							onClick={handleRequestSignUpOtp}
						>
							Create Account
						</Button>
						<div style={{ marginTop: 12 }}>
							<Text style={{ fontSize: 16 }}>Already have an account?</Text>
							<Link
								onClick={() => history.push('/login')}
								style={{ marginLeft: 5, fontSize: 16 }}
							>
								Login
							</Link>
						</div>
					</div>
				</Flex>
			</div>
		</div>
	);
};

export default SignUpPage;